import { ArrowLeft, ArrowRight } from "@phosphor-icons/react"
import { IconButton } from "~/components/reusable/Button"

type YearSelectorProps = {
  selectedYear: number
  onChange: (year: number) => void
  minYear?: number
  maxYear?: number
  highlightLeft?: boolean
  highlightRight?: boolean
  highlightLeftTooltip?: string
  highlightRightTooltip?: string
}

export function YearSelector({
  selectedYear,
  onChange,
  minYear,
  maxYear,
  highlightLeft,
  highlightRight,
  highlightLeftTooltip,
  highlightRightTooltip,
}: YearSelectorProps) {
  const canGoBack = minYear === undefined || selectedYear > minYear
  const canGoForward = maxYear === undefined || selectedYear < maxYear

  const leftClass =
    "disabled:shadow-none disabled:bg-transparent" +
    (highlightLeft && canGoBack ? " bg-badge-red-bg text-badge-red-fg-text" : "")
  const rightClass =
    "disabled:shadow-none disabled:bg-transparent" +
    (highlightRight && canGoForward ? " bg-badge-red-bg text-badge-red-fg-text" : "")

  return (
    <div className="flex flex-row h-[28px] shadow-button-neutral rounded-full">
      <IconButton
        size="sm"
        variant="transparent"
        className={leftClass}
        onClick={() => onChange(selectedYear - 1)}
        disabled={!canGoBack}
        title={highlightLeft && canGoBack ? highlightLeftTooltip : undefined}
      >
        <ArrowLeft />
      </IconButton>
      <div className="flex items-center justify-center h-full label-base min-w-[50px]">
        {selectedYear}
      </div>
      <IconButton
        size="sm"
        variant="transparent"
        onClick={() => onChange(selectedYear + 1)}
        className={rightClass}
        disabled={!canGoForward}
        title={highlightRight && canGoForward ? highlightRightTooltip : undefined}
      >
        <ArrowRight />
      </IconButton>
    </div>
  )
}
